import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSpironolactoneGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#332856"
  }, jsx("path", {
    d: "m28.4 8-16 4.1-4.4 16 11.6 11.8 16-4.1 4.4-16L28.4 8Zm6.2 26.7L20 38.5 9.4 27.7l4-14.5L28 9.4l10.6 10.8-4 14.5Z"
  }), jsx("path", {
    d: "M21.6 22.6c-.8-.3-1.1-.4-1.1-.9 0-.4.3-.7.7-.7.4 0 .7.3.8.8h1.3c0-1.3-.8-1.9-2-1.9s-2 .8-2 1.9c0 1.1.7 1.6 1.8 1.9.8.3 1.1.5 1.1.9s-.3.7-.8.7c-.6 0-1-.3-1-1h-1.3c0 1.2.8 2.1 2.2 2.1 1.2 0 2.1-.7 2.1-1.9 0-.9-.5-1.4-1.8-1.9ZM26.9 21.7c-.8 0-1.2.3-1.5.7l-.1-.6h-1l-.1 6.5h1.2v-2.4c.2.3.7.6 1.4.6 1.2 0 2.1-1 2.1-2.4s-.8-2.4-2-2.4Zm-.3 3.7c-.6 0-1.1-.5-1.1-1.3V24c0-.8.6-1.3 1.2-1.3s1.1.5 1.1 1.3c0 .9-.6 1.4-1.2 1.4ZM26.2 12.9l.7-.2.5.5c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.2.2-.5 0-.7l-.9-.9-1.1.4c-.3.1-.4.3-.3.6 0 .2.3.4.5.3ZM16 14.6l-1.2.3-.3 1.2c-.1.3 0 .5.3.6h.1c.2 0 .4-.1.5-.4l.2-.7.7-.2c.3-.1.4-.3.3-.6 0-.2-.3-.3-.6-.2ZM12.4 27l.2-.7c.1-.3-.1-.5-.3-.6-.3-.1-.5 0-.6.3l-.3 1.2.9.9c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.2.2-.5 0-.7l-.5-.4ZM21.4 35.1l-.7.2-.5-.5c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l.9.9 1.2-.3c.3-.1.4-.3.3-.6 0-.3-.3-.4-.5-.4ZM32.8 31.3c-.3-.1-.5.1-.6.3l-.2.8-.7.2c-.3.1-.4.3-.3.6.1.2.3.4.5.4h.1l1.2-.3.3-1.2c.1-.4 0-.7-.3-.8ZM35.3 19.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l.5.5-.1.7c-.1.3.1.5.3.6h.1c.2 0 .4-.1.5-.4l.3-1.2-.9-.9Z"
  })));
}

export { SvgSpironolactoneGlyph as default };
